const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let { default: fetch } = require('node-fetch');

async function getMemes(state) {let response, message;
  state.loading = true;
  try {
    response = await fetch('https://api.imgflip.com/get_memes');
  } catch(e) {
    console.log(e);
    state.loading = e.message;
    return 
  }
  message = await response.json();
  state.loading = false;
  state.memes = message.data.memes;
};

module.exports = { fetch, getMemes };
